<template>
  <Input ref="refInput" :class="{ 'content-center': isContentCenter }" v-bind="$attrs" :clearable="clearable" v-model="model" :style="{ width: width }" @on-blur="_blur" @on-clear="_clear">
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </Input>
</template>

<script setup>
import { ref } from 'vue'

const refInput = ref(null)
const model = defineModel()
const emit = defineEmits(['blur'])
const props = defineProps({
  // model: '',
  width: {
    type: String,
    default: ''
  },
  // 大于0
  moreZero: {
    type: Boolean,
    default: false
  },
  // 大于等于0
  moreAndEqualZero: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: true
  },
  isContentCenter: {
    type: Boolean,
    default: () => false
  },
  hasMustValue: {
    type: Boolean,
    default: false
  },
  // 输入框类型是整数
  mustInteger: {
    type: Boolean,
    default: false
  },
  mustValue: {
    type: [String, Number],
    default: () => 0
  }
})
function _blur() {
  //首尾去空格
  if (typeof model.value !== 'number' && model.value !== undefined) {
    model.value = model.value.replace(/(^\s*)|(\s*$)/g, '')
  }
  if (props.hasMustValue) {
    if (!!model.value === false) {
      model.value = props.mustValue
    } else {
      if (props.mustInteger) {
        // 必须有值且必须为整数
        let data = +model.value
        if (!Number.isInteger(data)) {
          model.value = props.mustValue
        }
      } else {
        // model.value = props.mustValue
      }
      if (props.moreZero) {
        let data = +model.value
        if (data <= 0) {
          model.value = props.mustValue
        }
      }
      if (props.moreAndEqualZero) {
        let data = +model.value
        if (data < 0) {
          model.value = props.mustValue
        }
      }
    }
  }
  emit('blur', model.value)
}
function _clear() {
  blur()
}
</script>

<style lang="less" scoped></style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.content-center {
  .ivu-input {
    text-align: center;
  }
}
</style>
